module.exports = __webpack_public_path__ + "static/media/phone-icon.8a94c90e.svg";